






























































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ManageMixin from '@/mixins/Manage.vue';
import UserData from '@/data/User';

@Component
export default class EditAgentView extends Mixins(ErrorHandleMixin, ManageMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  mainKey = 0;

  selected: any = {};

  productSelected: any = 'pg';

  isSuperadmin = ['SUPERADMIN'].includes(this.AuthInstance.user.role);

  isAgentAndSub = ['SUBAGENT', 'SUBACCOUNT', 'SUBCOMPANY', 'ADMIN', 'SUPERADMIN'].includes(this.AuthInstance.user.role)

  isAllowResetPassword = this.AuthInstance.user.role === 'ADMIN' && this.AuthInstance.user.userPermission.member === 'edit'

  isErrorPT = false;

  ptBefore = 0

  beforeMount() {
    const { id } = this.$router.currentRoute.params;
    if (!id) this.$router.go(-1);
  }

  async created() {
    const { id } = this.$router.currentRoute.params;
    this.selected = this.AccountInstance.users.users.find((item) => item._id === id);
    this.ptBefore = this.selected.pt.pg;
    this.selected.role = 'AGENT';
    if (this.selected.ipWhitelist) {
      this.selected.ipWhitelist = this.selected.ipWhitelist.join();
    }
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
  }

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const { code, message } = await this.AccountInstance.CreateAccount(this.selected);
    this.GeneralInstance.toggleLoading(false);
    if (code === 0) {
      this.selected = CreateAccountData.initialUserData();
      this.mainKey += 1;
    }
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  editPT() {
    this.modal.pt = true;
  }

  async submitEditPT(user) {
    this.currentSelectUser = user._id;
    const params = {
      userId: this.currentSelectUser,
      pt: {
        before: this.ptBefore,
        after: this.selected.pt.pg,
      },
    };
    const res = await this.AccountInstance.UpdateCommission(params);
    this.alert(res);
    this.ptBefore = this.selected.pt.pg;
    this.isErrorPT = res.code === 997;
  }
}
